<template>
  <section>
    <!-- 上传会议纪要 -->
    <div class="pop-room meeting-sumary-pop" v-if="addMeetingStatus">
      <a href="javascript:;" @click="$emit('hideMeetingSumary')" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="上传会议纪要">
              <attachments-sumary v-if="showAttachmentsSumary" :summaryData="summary ? summary.files : ''" style="margin-left:-15px;"
                ref="attachmentsSumary" :type='990'></attachments-sumary>
            </el-form-item>
            <el-form-item label="关联项目">
              <div class="person-room" v-if="projects.length>0">
                <span class="persion-item" v-for="p,i in projects">
                  {{p.name}}
                  <i @click="deleteProject(i)" class="iconfont icon-close1"></i>
                </span>
              </div>
              <div class="add-person">
                <el-button @click="$emit('showProjectList')" type="primary" size="mini" icon="el-icon-circle-plus-outline">选择相关工程</el-button>
              </div>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="addMeetingSummary()" class="form-btn" type="success">{{ meetingSummaryTitle }}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

    <!-- 工程列表 -->
    <div class="pop-room project-pop-room" v-if="projectListStatus">
      <a href="javascript:;" @click="$emit('hideProjectList')" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-select size="small" class="organization-select" v-model="projectDepId" placeholder="请选择所属公司">
          <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <div class="project-room">
          <el-input v-model="projectKey" size="small" placeholder="输入工程/项目名称搜索项目"></el-input>

          <div class="project-list" v-if="projectFilterList.length">
            <div class="project-item" v-for="p,i in projectFilterList" @click="selectedThis(p)">
              <span class="r" v-if="isSelected(p.id)">
                <span class="iconfont icon-duigou"></span>
              </span>
              {{ p.name }}
            </div>
          </div>
          <div class="project-list" v-else>
            <p class="no-list">暂无相关工程/项目</p>
          </div>
        </div>
        <el-button @click="$emit('hideProjectList')" size="mini" class="form-btn" type="success">确定</el-button>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";


  import meetingMixin from '@/Mixins/meetingMixin'
  import AttachmentsSumary from '@/components/AttachmentsSumary'
  export default {
    mixins: [meetingMixin],
    props: ['addMeetingStatus', 'meetingSumaryId', 'projectListStatus'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    components: {
      AttachmentsSumary,
    },
    data() {
      return {
        // 会议纪要
        projectDepId: "",
        projectKey: "",
        projectFilterList: [],
        projectList: [],
        projects: [],
        form: {
          conferenceId: '',
          files: [],
          projectIds: [],
          json: true,
        },

        // 会议纪要详情
        meetingSummaryTitle: "确认提交会议纪要",
        showAttachmentsSumary: false,
        summary: {},
      }
    },
    created() {
      this.organizationListData = this.organization[0].childDepts
      this.projectDepId = this.userData.secDepIds.split(",")[0] / 1
      this.getProjectList()

      // 获取会议纪要详情
      this.getMeetingSumary()
    },
    mounted() {

    },
    methods: {
      // 获取会议纪要详情
      getMeetingSumary() {
        ajax.post('/conference/summary/info', {
          conferenceId: this.meetingSumaryId
        }, (res) => {
          this.summary = res.vo
          this.showAttachmentsSumary = true
          if (this.summary) {
            this.projects = this.summary.projects
          }
        })
      },
      // 上传会议纪要
      addMeetingSummary() {
        let files = this.$refs.attachmentsSumary.getAttachments();
        // console.log(files)
        this.form.files = files
        this.form.conferenceId = this.meetingSumaryId
        this.form.projectIds = this.projects.map(item => item.id).join()

        // this.form.summary = summary
        if (this.summary) {

        }
        let _url = this.summary ? '/conference/summary/edit' : '/conference/summary/add'

        console.log(this.form)
        ajax.post(_url, this.form, (res) => {
          this.$message.success('提交会议纪要成功')
          this.$emit('hideMeetingSumary')
        })
      },

      // 选择工程/项目
      selectedThis(project) {
        if (this.isSelected(project.id)) {
          this.projects.splice(this.projects.indexOf(project), 1)
        } else {
          this.projects.push(project)
        }
      },
      // 删除选择工程
      deleteProject(index) {
        this.projects.splice(index, 1)
      },
      // 是否已选择该工程
      isSelected(pid) {
        for (var i = 0; i < this.projects.length; i++) {
          let _p = this.projects[i]
          if (pid == _p.id) {
            return true
          }
        }
        return false
      },
      // 筛选项目
      filterProjectList() {
        this.projectFilterList = []
        for (let i = 0; i < this.projectList.length; i++) {
          let _item = this.projectList[i]
          if (_item.name.indexOf(this.projectKey) != -1) {
            this.projectFilterList.push(_item)
          }
        }
      },
      // 获取项目列表
      getProjectList() {
        this.projectKey = ""
        ajax.get('/gc/project/parent/list', {
          depId: this.projectDepId
        }, (res) => {
          this.projectFilterList = this.projectList = res.vo.array
        })
      },
    },
    watch: {
      'projectDepId'() {
        this.getProjectList()
      },
      'projectKey'() {
        this.filterProjectList()
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/MeetingSumary.vue